<h2 mat-dialog-title>
  {{ 'FRONTEND.FORMS.SPECIAL_HOURS.TITLE' | translate }}
</h2>
<mat-dialog-content class="edit-special-hours-dialog__content">
  <forms-edit-special-time-period
    *ngFor="let day of this.convertedSpecialHours; let i = index"
    [dateWithHours]="day"
    (dateValueChange)="dateValueChange($event, i)"
    (hoursValueChange)="hoursValueChange($event, i)"
    (removeDate)="removeDateOnIndex(i)"
    (hasErrors)="hasErrors = $event"
  ></forms-edit-special-time-period>
  <div class="edit-special-hours-dialog__add-button">
    <button mat-stroked-button (click)="onAddNewDate()">
      <mat-icon>add</mat-icon>
      {{ 'FRONTEND.FORMS.SPECIAL_HOURS.ADD_NEW_DATE' | translate }}
    </button>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="edit-special-hours-dialog__buttons">
  <button mat-stroked-button matDialogClose class="cancel-button">
    {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.CANCEL' | translate }}
  </button>
  <button mat-flat-button [color]="'primary'" (click)="save()" [disabled]="hasErrors">
    {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.SAVE' | translate }}
  </button>
</mat-dialog-actions>
